import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Download, CalendarHeart, Mail } from "lucide-react";
import { GUIDE_URL } from "@/lib/api";

export default function Grazie() {
  const [params] = useSearchParams();
  const nome = params.get("nome");
  return (
    <main className="min-h-screen bg-[#F9F7F3] text-[#1E231F] flex items-center px-5 py-16" data-testid="grazie-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-xl mx-auto w-full"
      >
        <p className="text-[11px] uppercase tracking-[0.25em] font-bold text-[#748E63]">Fatto</p>
        <h1 className="font-display text-5xl sm:text-6xl tracking-tight leading-[1] mt-4" data-testid="grazie-title">
          Grazie{nome ? `, ${nome}` : ""}. La tua guida è pronta.
        </h1>
        <p className="mt-6 text-[#5A625C] text-lg leading-relaxed">
          Puoi scaricarla subito qui sotto. Te l'ho mandata anche per email, così la ritrovi quando vuoi.
        </p>
        <a
          href={GUIDE_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="grazie-download-button"
          className="btn-terra mt-8 h-14 px-8 rounded-full inline-flex items-center gap-3 font-semibold"
        >
          <Download className="w-5 h-5" /> Scarica la guida (PDF)
        </a>
        <div className="mt-6 flex items-start gap-3 text-sm text-[#5A625C]">
          <Mail className="w-4 h-4 mt-0.5 shrink-0" />
          <p>Non trovi l'email? Controlla in Promozioni o Spam e sposta il messaggio nella posta principale.</p>
        </div>

        <div className="mt-14 bg-white border border-[#E5E1D8] rounded-3xl p-7">
          <p className="font-display text-2xl">Vuoi un piano costruito su di te?</p>
          <p className="mt-2 text-[#5A625C] text-[15px] leading-relaxed">
            Prenota una chiamata conoscitiva gratuita di 20 minuti: parliamo dei tuoi obiettivi e capiamo insieme se il
            coaching 1:1 fa per te.
          </p>
          <Link
            to="/prenota"
            data-testid="grazie-book-call-link"
            className="btn-ghost mt-5 h-12 px-6 rounded-full inline-flex items-center gap-2 border border-[#1E231F] font-semibold text-sm hover:bg-[#1E231F] hover:text-white"
          >
            <CalendarHeart className="w-4 h-4" /> Prenota la chiamata
          </Link>
        </div>
        <Link to="/" className="mt-10 inline-block text-sm text-[#5A625C] link-underline" data-testid="grazie-home-link">
          Torna alla home
        </Link>
      </motion.div>
    </main>
  );
}
